import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ConfigurationElementDto } from '../type/dto/ConfigurationElementDto'
import { ConfigElement } from '../type/ConfigElement'
import { ConfigElementRule } from '../type/ConfigElementRule'
import { ConfigRuleVisible } from '../type/ConfigRuleVisible'
import { ConfigurationElementTypeDto } from '../enum/dto/ConfigurationElementTypeDto'
import { ConfigElementComponentType } from '../enum/ConfigElementComponentType'
import { ConfigRuleTypeDto } from '../enum/dto/ConfigRuleTypeDto'

const componentTypeByConfigurationType = {
    [ConfigurationElementTypeDto.ENUM]: ConfigElementComponentType.Dropdown,
    [ConfigurationElementTypeDto.BOOLEAN]: ConfigElementComponentType.Checkbox,
    [ConfigurationElementTypeDto.COLOR]: ConfigElementComponentType.ColorPicker,
    [ConfigurationElementTypeDto.NUMBER]: ConfigElementComponentType.QuantityPicker,
    [ConfigurationElementTypeDto.STRING]: ConfigElementComponentType.String,
    [ConfigurationElementTypeDto.TEXT]: ConfigElementComponentType.Text,
    [ConfigurationElementTypeDto.TEXTAREA]: ConfigElementComponentType.Textarea,
    [ConfigurationElementTypeDto.LIST]: ConfigElementComponentType.Datatable,
    [ConfigurationElementTypeDto.DATALIST]: ConfigElementComponentType.Select,
    [ConfigurationElementTypeDto.OBJECTLIST]: ConfigElementComponentType.ObjectSelect,
}

export class ConfigurationElementAdapter implements ApiDataAdapter<ConfigElement> {
    public createClass(element: ConfigurationElementDto): ConfigElement {
        const value = this.parseComponentValue(element.value, element.type)
        const globalValue = this.parseComponentValue(element.global, element.type)
        const defaultValue = this.parseComponentValue(element.default, element.type)
        const rules: ConfigElementRule[] = element.rules
            .map(rule => {
                switch (rule.type) {
                    case ConfigRuleTypeDto.VISIBLE:
                        return {
                            type: rule.type,
                            field: rule.field,
                            value: rule.value,
                        } as ConfigRuleVisible
                }
                return null
            })
            .flatMap(rule => (rule ? [rule] : [])) //remove null values

        return {
            key: element.key,
            label: element.label,
            description: element.description,
            value,
            default: defaultValue,
            global: globalValue,
            type: componentTypeByConfigurationType[element.type],
            rules,
            property: element.property,
        }
    }

    private parseComponentValue(value: string, componentType: ConfigurationElementTypeDto): unknown {
        switch (componentType) {
            case ConfigurationElementTypeDto.BOOLEAN:
                return value !== '0'
            case ConfigurationElementTypeDto.NUMBER:
                return parseInt(value) || undefined
            case ConfigurationElementTypeDto.LIST:
                return value ? value.split('|') : []
            case ConfigurationElementTypeDto.STRING:
            case ConfigurationElementTypeDto.TEXT:
            case ConfigurationElementTypeDto.TEXTAREA:
            case ConfigurationElementTypeDto.ENUM:
            case ConfigurationElementTypeDto.COLOR:
            case ConfigurationElementTypeDto.DATALIST:
            case ConfigurationElementTypeDto.OBJECTLIST:
                return value
            default:
                return undefined
        }
    }
}
